import React from 'react'
import FormRow from './formRow'

const MobileRecordForms = ({mobileForms}) => {
  const urlHost = window.location.origin

  return (
    <div className='m-10'>
      <h1 className='text-2xl my-4'>QFIELD GeoJson</h1>

      <h2 className='text-2xl my-4 underline'>Project Specific Routes</h2>
      <p>{urlHost}/api/mobile_records/geo_json?project_uuid={"{project_uuid}"}</p>
      <h2 className='text-2xl my-4 underline'>Project & Form Specific Routes</h2>
      <p>{urlHost}/api/mobile_records/geo_json?project_uuid={"{project_uuid}"}&record_type={"{form_name}"}</p>

      <table className='border-collapse text-left align-middle my-8'>
        <thead>
          <tr className='text-xl border-b-2 border-gray-500'>
            <th>Form Template Name</th>
            <th>GeoJSON Url</th>
          </tr>
        </thead>
        <tbody>
          {mobileForms.map(form => <FormRow key={form.id} form={form} urlHost={urlHost} />)}
        </tbody>
      </table>
    </div>
  )
}

export default MobileRecordForms
